import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

const StyledDialog = styled(Dialog)`
  font-family: var(--font-Pretendard);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #e7e9ec;
  background: rgba(249, 250, 251, 0.8);
  backdrop-filter: blur(8px);
`;

const HeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

const CloseButton = styled.button`
  padding: 0;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
`;

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

const StyledContent = styled.div`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

const EvidenceDescription = styled(StyledContent)`
  color: #888d96;
`;

const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 12px;
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e7e9ec;
`;

const SubmitButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 6px;
  background-color: black;
  color: white;
  :disabled {
    background-color: #d1d8e2;
  }
`;

const LayoutUpload = styled.div`
  display: flex;
  background-color: #f9fafb;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
`;

const StyledXButton = styled.button`
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  > svg {
    vertical-align: middle;
  }
`;

const UploadLeftSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const UploadRightSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

const FileSize = styled.div`
  color: #888d96;
`;

const ReasonContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
  gap: 6px;
`;

const ReasonText = styled.div<{ $failed?: boolean }>`
  color: ${({ $failed }) => ($failed ? '#F55060' : '#43B16F')};
  display: flex;
  align-items: center;
  gap: 2px;
`;

export {
  StyledXButton,
  LayoutUpload,
  UploadLeftSection,
  UploadRightSection,
  FileSize,
  ReasonContainer,
  ReasonText,
  StyledDialog,
  Header,
  HeaderTitle,
  CloseButton,
  Body,
  ContentLayout,
  StyledTitle,
  StyledContent,
  EvidenceDescription,
  ActionRow,
  CancelButton,
  SubmitButton,
};
